import React, { Suspense, useCallback, useContext, useEffect, useState } from "react";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { getClosedSummaryListData } from "./Service/ReportService";
import { TostMsg } from "../../../App";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Papa from "papaparse";
import { saveAs } from "file-saver";
import { debounce } from "lodash";

function RequestClosedSummary() {
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [Isloading, setIsloading] = useState(false);
  const toster = useContext(TostMsg);
  const [closedSummaryData, setClosedSummaryData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filteredData, setFilteredData] = useState(closedSummaryData);
  const [masterSystemAlertData, setMasterSystemAlertData] = useState([]);

  const [selectOpenSummery, setSelectOpenSummery] = useState([]);
  const selectedColumns = [
    "CategoryName",
    "CategoryOwner",
    "SubCategoryName",
    "ActiveTickets",
    "ClosedTickets",
    "Pending0D",
    "Resolved0D",
    "Critical",
    "AvgResolutionTime",
    "CategoryOwnerEmail",
    "MaxAssignments",
    "ResolvedLessThan3D",
    "ResolvedLessThan7D",
    "SLABreachPercentage",
  ];

  function exportToCSV() {
    if (!selectOpenSummery || selectOpenSummery.length === 0) {
      toster.current.warn("Please select at least one record");
      return;
    }
    const filteredData = selectOpenSummery.map((row) =>
      selectedColumns.reduce((acc, col) => {
        acc[col] = row?.[col] ?? "";
        return acc;
      }, {})
    );
    const csv = Papa.unparse(filteredData);
    const blob = new Blob([csv], {
      type: "text/csv;charset=utf-8;",
    });
    saveAs(blob, "ClosedSummaryReport.csv");
  }

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setMasterSystemAlertData(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        // setMasterSystemAlertData(msg?.Desc);
      }
    });
  }, []);

  const onSortChange = (e) => {
    setSortField(e.sortField);
    setSortOrder(e.sortOrder);

    const sortedData = [...filteredData].sort((a, b) => {
      let valueA = a[e.sortField];
      let valueB = b[e.sortField];

      if (typeof valueA === "string") valueA = valueA.toLowerCase();
      if (typeof valueB === "string") valueB = valueB.toLowerCase();

      if (valueA < valueB) return e.sortOrder;
      if (valueA > valueB) return -e.sortOrder;
      return 0;
    });

    setFilteredData(sortedData);
  };

  const onPageChange = (e) => {
    setCurrentPage(e.first / e.rows);
    setRowsPerPage(e.rows);
  };


  useEffect(() => {
    GetMasterSystemAlertList("Tickets_Closed_Report", 1);
    getClosedSummaryList();
  }, []);

  async function getClosedSummaryList() {
    setIsloading(true);
    try {
      let ClosedSummaryList = await getClosedSummaryListData({});

      const updatedData = ClosedSummaryList?.Data.map((item, index) => ({
        ...item,
        uniqueId: `${item.CategoryName}-${item.SubCategoryName}-${index}`
      }));

      setClosedSummaryData(updatedData);
      setFilteredData(updatedData);
      setIsloading(false);
    } catch (error) {
      toster.current.error(ERROR_LIST.DefaultError);
      setIsloading(false);
    }
  }

  const handleSearch = useCallback(
    debounce((value) => {
      if (!value) {
        setFilteredData(closedSummaryData);
        return;
      }

      const lowerCaseValue = value.toLowerCase();

      const filtered = closedSummaryData.filter((item) =>
        Object.keys(item).some((key) =>
          String(item[key]).toLowerCase().includes(lowerCaseValue)
        )
      );

      setFilteredData(filtered);
      setCurrentPage(0); // reset pagination
    }, 500),
    [closedSummaryData]
  );

  const maxAssignmentsBody = (rowData) => {
    const value = rowData?.MaxAssignments;
    if (!value) return "-";
    const valuesArray = Array.isArray(value)
      ? value
      : String(value).split(",");
    const trimmedValues = valuesArray.map(v => v.trim());

    const fullText = trimmedValues.join(", ");

    let displayText = fullText;

    if (trimmedValues.length > 2) {
      const firstTwo = trimmedValues.slice(0, 2).join(", ");
      const remainingCount = trimmedValues.length - 2;
      displayText = `${firstTwo} +${remainingCount} more`;
    }

    return (
      <span
        title={trimmedValues.join("\n")}
        style={{ cursor: "pointer" }}
      >
        {displayText}
      </span>
    );
  };

  return (
    <div>
      <div className="container-fluid position-relative">
        <div className="row team-directories g-3">
          {/* HEADER */}
          <div className="col-xl-12">
            <div className="form-head d-flex flex-wrap align-items-center">
              <div className="me-auto">
                <h2 className="font-w600 mb-0">Closed Requests Summary</h2>
                {/* <p>{masterSystemAlertData}</p> */}
                <p>All closed ticket requests.</p>
              </div>
              <div className="rightside-tabs">
                <Link to="/Reports">
                  <button className="back-newticket w-auto float-right">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-arrow-left-short"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                      />
                    </svg>{" "}
                    Back
                  </button>
                </Link>
              </div>

            </div>
          </div>

          <div className="col-xl-12">
            <div className="card">
              <div className="card-body">
                <div className="form-head d-flex flex-wrap align-items-center mb-3">
                  <div className="me-auto">
                    <strong>Tickets</strong>
                  </div>
                  <div className="actionbutton-tickets rightside-tabs">
                    <input
                      type="text"
                      className="form-control"
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        handleSearch(e.target.value);
                      }}
                      placeholder="Search"
                    />
                    <button
                      className="export-btn"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Export"
                      onClick={() => exportToCSV()}
                    >
                      <img
                        src="/images/excels.png"
                        alt="export"
                        style={{ width: "21px" }}
                      />
                    </button>
                  </div>
                </div>
                <div className="table-responsive">
                  <div className="table table-bordered Employeelist ">
                    <DataTable
                      value={filteredData}
                      dataKey="uniqueId"
                      tableStyle={{ minWidth: "60rem", fontSize: "12px" }}
                      paginator
                      rows={rowsPerPage}
                      first={currentPage * rowsPerPage}
                      totalRecords={filteredData.length}
                      rowsPerPageOptions={[10, 25, 50, 100]}
                      sortField={sortField}
                      sortOrder={sortOrder}
                      onSort={onSortChange}
                      onPage={onPageChange}
                      paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                      selection={selectOpenSummery}
                      onSelectionChange={(e) => setSelectOpenSummery(e.value)}
                      selectionPageOnly={false}
                    >
                      <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
                      <Column field="CategoryName" header="Category Name" />
                      <Column field="SubCategoryName" header="Sub Category" />
                      <Column field="ClosedTickets" header="Closed Tickets" />
                      <Column field="Resolved0D" header="Resolved" />
                      <Column field="ResolvedLessThan3D" header="Resolved Less Then 3D" />
                      <Column field="ResolvedLessThan7D" header="Resolved Less Then 7D" />
                      <Column field="SLABreach" header="SLA Breach" />
                      <Column field="AvgResolutionTime" header="Avg Resolution Time" />
                      <Column body={(rowData) => rowData.SLABreachPercentage ?? "0.00%"} header="SLA Breach %" />
                      <Column body={maxAssignmentsBody} header="Max Assignments" />
                      <Column field="CategoryOwner" header="Raise By" />
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {Isloading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : ("")}
    </div>
  );
}

export default RequestClosedSummary;
